import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { Administrative } from 'src/permissions/product-lines/administrative/administrative.setup';
import {
  UsersRolesRolesTab,
  UsersRolesUsersTab,
  UsersRolesScopesTab,
} from './tabs';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const parent = Administrative.pages.usersRoles;
const title = 'PAGE.USERS_ROLES.TITLE';
const tabs: TabPermission[] = [
  UsersRolesRolesTab,
  UsersRolesUsersTab,
  UsersRolesScopesTab,
];

export const UsersRolesPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
